;

var CCCLabelEngine = function (map) {
	this.map = map;

	class Point {
		constructor(x, y) {
			this.x = x;
			this.y = y;
		}
	}

	this.labelGun = new labelgun.default(
		function hideLabel(label) {
			//console.debug('hideLabel', label.id, label.name);
			label.labelObject.classList.add("overlay-label--hidden");
		},
		function showLabel(label) {
			//console.debug('showLabel', label.id, label.name);
			label.labelObject.classList.remove("overlay-label--hidden");
		}
	);

	this.renderLabels = _.debounce(function(overlayMarkers, beforeTask, afterTask) {
		if (beforeTask instanceof Function) {
			beforeTask();
		}

		if (!(overlayMarkers && overlayMarkers.length)) {
			console.debug('No labels to render');
			if (afterTask instanceof Function) {
				afterTask();
			}
			return;
		}
		var self = this;

		// Google maps renders map markers (like our labels) asynchronously
		// There's no event to tell when it's done - "idle" doesn't work
		// So we just have to wait, based on how many markers there are
		var delayPerMarker = 13; // 10 works fine, but include a buffer
		var delayLength = overlayMarkers.length * delayPerMarker;
		console.debug('delayLength', delayLength);

		setTimeout(function() {
			resetAndUpdateLabels(overlayMarkers, afterTask instanceof Function ? afterTask : null);
		}, delayLength);
		
		function resetAndUpdateLabels (overlayMarkers, cb) {
			console.debug('labelGun.reset() start');
			self.labelGun.reset();
			console.debug('labelGun.reset() end');
	
			if (!overlayMarkers) {
				console.debug('No new overlay markers');
				return;
			}
	
			overlayMarkers.forEach(ingestSingleLabel, self);
	
			console.debug('labelGun.update start');
			self.labelGun.update(false);
			console.debug('labelGun.update end');
	
			if (cb instanceof Function) {
				cb();
			}
	
			function ingestSingleLabel (element, index, array) {
				// Use LabelGun to show/hide overlapping labels
				var labelDiv = element.label.labelDiv_;
		
				// We need the bounding rectangle of the label itself
				var rect = labelDiv.getBoundingClientRect();
		
				// We convert the container coordinates (screen space) to Lat/lng
				var bottomLeft = point2LatLng(new google.maps.Point(rect.left, rect.bottom), map);
				var topRight = point2LatLng(new google.maps.Point(rect.right, rect.top), map);
				var boundingBox = {
					bottomLeft: [bottomLeft.lng(), bottomLeft.lat()],
					topRight: [topRight.lng(), topRight.lat()]
				}
		
				// Ingest the label into labelgun itself
				var now = performance.now();
				self.labelGun.ingestLabel(
					boundingBox,
					"id|" + index,
					parseInt(Math.random() * (5 - 1) + 1), // Weight
					labelDiv,
					element.labelContent,
					false
				);
			};
			
			function point2LatLng (point, map) {
				var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
				var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
				var scale = Math.pow(2, map.getZoom());
				var worldPoint = new google.maps.Point(point.x / scale + bottomLeft.x, point.y / scale + topRight.y);
				return map.getProjection().fromPointToLatLng(worldPoint);
			};
		};
	}, 100);
};